/**
 * Convert string to match E.164 phone number pattern (e.g. +1234567890),
 * otherwise return empty string.
 */
/* eslint-disable import/prefer-default-export */
export const convertTelToE164 = (string) => {
  const newString = string.replace(/\D/g, '');
  return newString.length <= 14 ? `+${newString}` : `+${newString.slice(0, 14)}`;
};
